export default function updateBlacklistEndDate(handleEndDate) {
  const currentDate = new Date();
  currentDate.setFullYear(currentDate.getFullYear() + 1);
  handleEndDate(currentDate.toISOString());
}
